import type {Weekday} from '#lit/common/constants/dates.js';
import {isWeekday, setWeekday} from '#lit/common/constants/dates.js';

export function validateWeekdays(value: unknown[]): Weekday[] {
  return value
    .filter(n => isWeekday(Number(n)))
    .map(n => setWeekday(Number(n)));
}

export type ChangeWeekdayEventDetail = {
  values: Weekday[];
  change: {
    action: 'select' | 'deselect';
    value: Weekday;
  };
};

export class ChangeWeekdayEvent extends CustomEvent<ChangeWeekdayEventDetail> {
  static eventName = 'change:weekday' as const;

  private constructor(detail: ChangeWeekdayEventDetail) {
    super(ChangeWeekdayEvent.eventName, {
      bubbles: true,
      cancelable: true,
      composed: true,
      detail,
    });
  }

  static create(detail: ChangeWeekdayEventDetail) {
    return new ChangeWeekdayEvent(detail);
  }
}

declare global {
  interface HTMLElementEventMap {
    [ChangeWeekdayEvent.eventName]: ChangeWeekdayEvent;
  }
}
